import { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// import { useLSState } from 'nanoweb-react';
import { useLSState } from '../utils/localStorage';

const AppContext = createContext();

const AppProvider = ({ children }) => {
	const [_, set_] = useState({});
	const [theme, setTheme] = useLSState('theme', 'system');
	// const [theme, setTheme] = useState('system');
	useEffect(() => {
		const fetchLangs = async () => {
			set_({});
		};
		fetchLangs();
	}, []);

	// Handle theme switching
	useEffect(() => {
		const rootElement = document.documentElement;
		// Apply the theme or fall back to the system default
		if (theme === 'dark' || theme === 'light') {
			rootElement.setAttribute('data-bs-theme', theme);
		} else {
			rootElement.removeAttribute('data-bs-theme'); // Use system default
		}
	}, [theme]);

	const toggleTheme = () => {
		// Toggle between light, dark, and system
		setTheme((prevTheme) => {
			if (prevTheme === 'light') return 'dark';
			return 'light';
		});
	};

	const t = (key, defaultValue) => {
		if ('undefined' !== typeof _[key]) {
			return _[key];
		}
		if ('undefined' === typeof defaultValue) {
			return key;
		}
		return defaultValue;
	};

	const value = {
		t,
		theme, toggleTheme,
	};

	return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

AppProvider.useContext = () => useContext(AppContext);

// Add prop-types validation for 'children'
AppProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export default AppProvider;
